module.exports = __webpack_public_path__ + "static/media/ic_PDF_cloud.317613e2.svg";